export default {"src":"/_next/static/media/ElectricityMeters.01f3ea8d.svg","height":63,"width":89};